import { render } from "./Submenus.vue?vue&type=template&id=95b8b310&scoped=true&ts=true"
import script from "./Submenus.vue?vue&type=script&lang=ts"
export * from "./Submenus.vue?vue&type=script&lang=ts"

import "./Submenus.vue?vue&type=style&index=0&id=95b8b310&lang=scss&scoped=true"

import exportComponent from "E:\\Code\\hjp\\yijian-proxy-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-95b8b310"]])

export default __exports__